/* Blankydoodle theme — vanilla JS, no dependencies */
(() => {
  'use strict';
  const BD = window.BD || { routes: { root: '/', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update' }, strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (BD.routes.root || '/').replace(/\/?$/, '/');

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);
    format = format || BD.money || '${{amount}}';
    const fmt = (n, d, ts = ',', ds = '.') => {
      const s = (n / 100).toFixed(d).split('.');
      s[0] = s[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + ts);
      return s[1] ? s[0] + ds + s[1] : s[0];
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }
  BD.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    requestAnimationFrame(() => t.classList.add('is-show'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { t.classList.remove('is-show'); setTimeout(() => (t.hidden = true), 300); }, 2600);
  }

  /* ---------- Reveal / color-in ---------- */
  function initReveal(scope = document) {
    const els = $$('[data-reveal], .hl-animate, [data-color-in]', scope);
    if (!('IntersectionObserver' in window)) { els.forEach(el => colorIn(el)); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        colorIn(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(el => io.observe(el));
  }
  function colorIn(el) {
    el.classList.add('is-in');
    const d = el.matches('[data-color-in]') ? $('.doodle', el) : null;
    if (d) setTimeout(() => d.classList.add('is-colored'), 250);
  }

  /* ---------- Header ---------- */
  function initHeader() {
    const h = $('.header'); if (!h) return;
    const on = () => h.classList.toggle('is-scrolled', window.scrollY > 8);
    on(); window.addEventListener('scroll', on, { passive: true });
  }

  /* ---------- Announcement + countdowns ---------- */
  function initAnnouncement() {
    $$('[data-announce]').forEach(bar => {
      const items = $$('.announce__item', bar);
      // countdowns
      $$('[data-countdown]', bar).forEach(el => {
        const end = Number(el.dataset.countdown) * 1000;
        const out = $('[data-countdown-time]', el);
        const tick = () => {
          const ms = end - Date.now();
          const win = (Number(el.dataset.showDays) || 9999) * 864e5;
          if (!end || ms <= 0 || ms > win) { el.closest('.announce__item')?.remove(); return false; }
          const d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
          if (out) out.textContent = d > 0 ? `${d}d ${h}h ${m}m` : `${h}h ${m}m ${String(s).padStart(2, '0')}s`;
          return true;
        };
        if (tick()) setInterval(tick, 1000);
      });
      const live = () => $$('.announce__item', bar);
      if (live().length) live()[0].classList.add('is-active');
      if (items.length < 2) return;
      let i = 0;
      setInterval(() => {
        const list = live(); if (list.length < 2) return;
        list[i % list.length].classList.remove('is-active');
        i = (i + 1) % list.length;
        list[i].classList.add('is-active');
      }, Number(bar.dataset.interval) || 4000);
    });
  }

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    $$(`[aria-controls="${id}"]`).forEach(b => b.setAttribute('aria-expanded', 'true'));
    setTimeout(() => $('[data-close].icon-btn', d)?.focus({ preventScroll: true }), 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.documentElement.classList.remove('no-scroll');
    $$(`[aria-controls="${d.id}"]`).forEach(b => b.setAttribute('aria-expanded', 'false'));
    lastFocus?.focus?.({ preventScroll: true });
  }
  BD.openCart = () => openDrawer('CartDrawer');
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      if (opener.dataset.open === 'CartDrawer' && document.body.classList.contains('template-cart')) return;
      e.preventDefault(); openDrawer(opener.dataset.open); return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer); });

  /* ---------- Cart ---------- */
  const isCartPage = () => document.body.classList.contains('template-cart');
  function updateCount(count) {
    $$('[data-cart-count]').forEach(el => {
      el.textContent = count; el.hidden = count === 0;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }
  function renderDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('.drawer__panel', doc), cur = $('#CartDrawer .drawer__panel');
    if (fresh && cur) { cur.innerHTML = fresh.innerHTML; initReveal(cur); fixShipBar(cur); }
  }
  // Free-shipping bar: convert the shop-currency threshold into the shopper's currency (Markets)
  function fixShipBar(root) {
    const cur = window.Shopify && Shopify.currency;
    $$('[data-ship]', root || document).forEach(el => {
      const rate = cur && Number(cur.rate) || 1;
      if (rate === 1) return;
      const base = Math.round(Number(el.dataset.base) * rate), total = Number(el.dataset.total);
      const rem = base - total, pct = Math.min(100, Math.round(total / base * 100));
      const msg = $('[data-ship-msg]', el), fill = $('[data-ship-fill]', el);
      if (msg) msg.innerHTML = rem > 0 ? el.dataset.msg.replace('[amount]', `<b>${formatMoney(rem)}</b>`) : el.dataset.done;
      if (fill) fill.style.width = pct + '%';
    });
  }
  BD.fixShipBar = fixShipBar;
  async function refreshCart() {
    if (isCartPage()) { location.reload(); return; }
    const [sec, cart] = await Promise.all([
      fetch(`${root}?sections=cart-drawer`).then(r => r.json()).catch(() => null),
      fetch(`${root}cart.js`).then(r => r.json()).catch(() => null)
    ]);
    if (sec) renderDrawer(sec['cart-drawer']);
    if (cart) updateCount(cart.item_count);
  }
  async function addToCart(items) {
    const res = await fetch(`${BD.routes.cartAdd}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || BD.strings.error);
    if (data.sections) renderDrawer(data.sections['cart-drawer']);
    const cart = await fetch(`${root}cart.js`).then(r => r.json());
    updateCount(cart.item_count);
    return data;
  }
  BD.addToCart = addToCart;
  async function changeLine(line, quantity) {
    const body = $('#CartDrawer .drawer__panel'); body?.classList.add('is-busy');
    try {
      const res = await fetch(`${BD.routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: 'cart-drawer', sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || BD.strings.error);
      if (data.items && data.items.length && data.items.every(i => i.product_type === 'Add-on')) {
        const updates = {}; data.items.forEach(i => (updates[i.key] = 0));
        await fetch(`${BD.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
        if (isCartPage()) { location.reload(); return; }
        await refreshCart(); return;
      }
      if (isCartPage()) { location.reload(); return; }
      if (data.sections) renderDrawer(data.sections['cart-drawer']);
      updateCount(data.item_count);
    } catch (err) { toast(err.message); refreshCart(); }
    finally { body?.classList.remove('is-busy'); }
  }
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-change]');
    if (step) {
      const input = $('input', step.closest('.qty'));
      const q = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.qtyChange));
      input.value = q; changeLine(Number(input.dataset.qtyLine), q); return;
    }
    const nudge = e.target.closest('[data-nudge-line]');
    if (nudge) { nudge.disabled = true; changeLine(Number(nudge.dataset.nudgeLine), Number(nudge.dataset.nudgeQty)); return; }
    const rm = e.target.closest('[data-remove]');
    if (rm) { changeLine(Number(rm.dataset.remove), 0); return; }
    const qa = e.target.closest('[data-quick-add]');
    if (qa) {
      qa.disabled = true;
      addToCart([{ id: Number(qa.dataset.quickAdd), quantity: Number(qa.dataset.quickQty) || 1 }]).then(() => { if (isCartPage()) location.reload(); }).catch(err => toast(err.message)).finally(() => (qa.disabled = false));
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-line]');
    if (input) changeLine(Number(input.dataset.qtyLine), Math.max(0, parseInt(input.value, 10) || 0));
  });
  let noteTimer;
  document.addEventListener('input', (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => {
      fetch(`${BD.routes.cartUpdate}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }, 500);
  });

  /* ---------- Gallery ---------- */
  function initGallery(g) {
    const vp = $('[data-gallery-viewport]', g); if (!vp) return;
    const allSlides = $$('.gallery__slide', vp);
    const allDots = $$('.gallery__dots span', g);
    const allThumbs = $$('[data-gallery-thumb]', g);
    const counter = $('[data-gallery-current]', g);
    const total = $('[data-gallery-total]', g);
    const on = (el) => !el.classList.contains('is-off');
    let slides = [], dots = [], thumbs = [];
    const refresh = () => {
      slides = allSlides.filter(on); dots = allDots.filter(on); thumbs = allThumbs.filter(on);
      if (total) total.textContent = slides.length;
      const nav = slides.length > 1;
      $$('.gallery__count, .gallery__dots, .gallery__arrows, .gallery__thumbs', g).forEach(el => (el.style.display = nav ? '' : 'none'));
    };
    refresh();
    let current = 0;
    const setActive = (i, force) => {
      if (!force && i === current && counter?.textContent === String(i + 1)) return;
      current = i;
      allDots.forEach(d => d.classList.toggle('is-active', d === dots[i]));
      allThumbs.forEach(t => t.classList.toggle('is-active', t === thumbs[i]));
      if (counter) counter.textContent = i + 1;
      const th = thumbs[i]; if (th) th.parentElement.scrollTo({ left: th.offsetLeft - 40, behavior: 'smooth' });
      slides.forEach((s, j) => { const v = $('video', s); if (v) { if (j === i) v.play().catch(() => {}); else v.pause(); } });
    };
    const goTo = (i, smooth = true) => {
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (!slides[i]) return;
      vp.scrollTo({ left: slides[i].offsetLeft - vp.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(i);
    };
    let raf;
    vp.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setActive(Math.round(vp.scrollLeft / vp.clientWidth)));
    }, { passive: true });
    allThumbs.forEach(t => t.addEventListener('click', () => goTo(thumbs.indexOf(t))));
    $('[data-gallery-prev]', g)?.addEventListener('click', () => goTo(current - 1));
    $('[data-gallery-next]', g)?.addEventListener('click', () => goTo(current + 1));
    vp.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') goTo(current + 1); if (e.key === 'ArrowLeft') goTo(current - 1); });
    g.goToMedia = (mediaId) => {
      const idx = slides.findIndex(s => s.dataset.mediaId === String(mediaId));
      if (idx > -1) goTo(idx);
    };
    // Show only the selected design's photos (plus shared 'all' media)
    g.setDesign = (slug) => {
      if (!allSlides.some(s => s.dataset.design === slug)) return;
      [...allSlides, ...allDots, ...allThumbs].forEach(el => {
        const d = el.dataset.design;
        el.classList.toggle('is-off', !(d === slug || d === 'all'));
      });
      refresh();
      slides.forEach(s => { const im = $('img', s); if (im) im.loading = 'eager'; });
      vp.scrollTo({ left: 0, behavior: 'auto' });
      setActive(0, true);
      g.classList.remove('is-swap'); void g.offsetWidth; g.classList.add('is-swap');
    };
  }

  /* ---------- Product buy box ---------- */
  function initBuybox(box) {
    const section = box.closest('[data-product-section]');
    let product;
    try { product = JSON.parse($('[data-product-json]', box).textContent); } catch (e) { return; }
    const gallery = $('[data-gallery]', section);
    const form = $('[data-product-form]', box);
    const idInput = $('[data-variant-id]', box);
    const qtyInput = $('[data-qty-input]', box);
    const atc = $('[data-atc]', box);
    const atcLabel = $('[data-atc-label]', box);
    const atcPrice = $('[data-atc-price]', box);
    const baseAtcText = atcLabel ? (atcLabel.dataset.text = atcLabel.textContent.trim()) : BD.strings.addToCart;
    const optionSets = $$('[data-option-index]', box);
    const bundleInputs = $$('[data-bundle-input]', box);
    const addonInputs = $$('[data-addon]', box);
    const addonTotal = (qty) => addonInputs.reduce((t, a) => t + (a.checked ? Number(a.dataset.price) * ('per' in a.dataset ? qty : 1) : 0), 0);
    let variant = product.variants.find(v => String(v.id) === idInput?.value) || product.variants[0];
    let designs = {}; try { designs = JSON.parse($('#BDDesigns')?.textContent || '{}'); } catch (e) {}
    const designSet = $('[data-design-option]', box);
    const designIdx = designSet ? Number(designSet.dataset.optionIndex) : -1;
    const designNames = designSet ? $$('input', designSet).map(i => i.value) : [];
    const slugify = (t) => String(t).toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const mix = $('[data-mix]', box);
    const mixList = $('[data-mix-list]', box);
    let mixPicks = [];   // design per blanket (index 0 = main swatch)
    let custom = [];     // true once a blanket's design was changed by hand
    const swatch = (name) => { const t = designSet && $$('input', designSet).find(i => i.value === name); return t ? ($('.dtile__c', t.nextElementSibling) || $('img', t.nextElementSibling))?.src : ''; };
    const variantForDesign = (name) => product.variants.find(v => v.options.every((o, k) => k === designIdx ? o === name : o === variant?.options[k]));

    function applyDesign(name, animate) {
      if (designIdx < 0 || !name) return;
      const slug = slugify(name);
      const d = designs[name] || {};
      document.documentElement.dataset.design = slug;
      $$('[data-design-tag]', box).forEach(el => (el.textContent = d.tag ? '· ' + d.tag : ''));
      gallery?.setDesign?.(slug);
      $$('[data-design-rail]', section).forEach(r => {
        const nm = $('[data-drail-name]', r); if (nm) nm.textContent = name;
        $$('.drail__btn', r).forEach(b => {
          const on = b.dataset.designName === name;
          b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
          if (on) { const l = $('.drail__list', r); l.scrollTo({ left: b.offsetLeft - l.clientWidth / 2 + b.clientWidth / 2, behavior: animate ? 'smooth' : 'auto' }); }
        });
      });
      // swap before/after art on the page
      if (d.ba0 && d.ba1) $$('[data-ba]').forEach(ba => {
        const imgs = $$('img', ba); if (imgs.length < 2) return;
        [[imgs[0], d.ba0], [imgs[1], d.ba1]].forEach(([im, src]) => { im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = src; });
      });
      const sImg = $('[data-sticky-atc] .sticky-atc__img img', section); const sw = swatch(name); if (sImg && sw) { sImg.removeAttribute('srcset'); sImg.src = sw; }
      if (animate) document.dispatchEvent(new CustomEvent('bd:design', { detail: { name, slug } }));
    }

    $$('[data-design-rail] .drail__btn', section).forEach(b => b.addEventListener('click', () => {
      const inp = designSet && $$('input', designSet).find(x => x.value === b.dataset.designName);
      if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
    }));

    // Per-blanket designs live inside the selected bundle card. Blanket 1 = the main swatch; others follow it until changed.
    function renderMix(qty) {
      if (!mix || designIdx < 0) return;
      const cur = variant ? variant.options[designIdx] : designNames[0];
      mixPicks[0] = cur;
      for (let i = 1; i < qty; i++) if (!mixPicks[i] || !custom[i]) mixPicks[i] = cur;
      mixPicks.length = qty; custom.length = qty;
      mix.hidden = qty < 2;
      if (qty < 2) return;
      const card = bundleInputs.find(i => i.checked)?.closest('.bundle');
      if (card && mix.previousElementSibling !== card) card.after(mix);
      mixList.innerHTML = '';
      mixPicks.forEach((name, i) => {
        const li = document.createElement('li'); li.className = 'mix__row';
        const img = document.createElement('img'); img.src = swatch(name); img.alt = ''; img.width = 48; img.height = 48;
        const lab = document.createElement('span'); lab.className = 'mix__n'; lab.textContent = 'Blanket ' + (i + 1);
        const sel = document.createElement('select'); sel.setAttribute('aria-label', 'Design for blanket ' + (i + 1));
        designNames.forEach(n => { const o = document.createElement('option'); o.value = n; o.textContent = n; if (n === name) o.selected = true; sel.appendChild(o); });
        sel.addEventListener('change', () => {
          if (i === 0) { const inp = $$('input', designSet).find(x => x.value === sel.value); if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); } return; }
          mixPicks[i] = sel.value; custom[i] = true; img.src = swatch(sel.value);
          gallery?.setDesign?.(slugify(sel.value));   // preview this blanket's design in the big photo
          li.animate?.([{ transform: 'scale(.97)' }, { transform: 'scale(1)' }], { duration: 160 });
        });
        li.append(img, lab, sel); mixList.appendChild(li);
      });
    }

    const getBundle = () => {
      const b = bundleInputs.find(i => i.checked);
      return b ? { qty: Number(b.dataset.qty) || 1, pct: Number(b.dataset.pct) || 0 } : { qty: 1, pct: 0 };
    };
    const selectedOptions = () => optionSets.map(fs => $('input:checked', fs)?.value);

    function render() {
      const { qty, pct } = getBundle();
      const unit = variant.price;
      // match checkout: Shopify floors the % discount per unit (39.99 x 10% -> 3.99 off)
      const total = (unit - Math.floor(unit * pct / 100)) * qty;
      const wasUnit = Math.max(variant.compare_at_price || 0, unit);
      const was = wasUnit * qty;
      const showWas = was > total;
      $$('[data-price-now]', box).forEach(el => (el.textContent = formatMoney(total)));
      $$('[data-price-was]', box).forEach(el => { el.textContent = formatMoney(was); el.hidden = !showWas; });
      $$('[data-price-save]', box).forEach(el => { el.hidden = !showWas; const a = $('[data-price-save-amount]', el); if (a) a.textContent = formatMoney(was - total); });
      if (qtyInput) qtyInput.value = qty;
      const extra = addonTotal(qty);
      if (atcPrice) atcPrice.textContent = formatMoney(total + extra);
      addonInputs.forEach(a => {
        const row = a.closest('.addon'); row?.classList.toggle('is-on', a.checked);
        if (!('per' in a.dataset)) return;
        const pr = $('[data-addon-price]', row), each = $('[data-addon-each]', row);
        if (pr) pr.textContent = '+' + formatMoney(Number(a.dataset.price) * qty);
        if (each) { each.hidden = qty < 2; each.textContent = qty + ' × ' + formatMoney(Number(a.dataset.price)); }
      });
      // bundle cards
      bundleInputs.forEach(inp => {
        const q = Number(inp.dataset.qty) || 1, p = Number(inp.dataset.pct) || 0;
        const card = inp.closest('.bundle');
        const t = (unit - Math.floor(unit * p / 100)) * q;
        const tot = $('[data-bundle-total]', card); if (tot) tot.textContent = formatMoney(t);
        const full = $('[data-bundle-full]', card); if (full) full.textContent = formatMoney(unit * q);
        const each = $('[data-each]', card); if (each) each.textContent = formatMoney(Math.round(t / q));
      });
      // availability
      if (atc) {
        const ok = variant && variant.available;
        atc.disabled = !ok;
        if (atcLabel) atcLabel.textContent = !variant ? BD.strings.unavailable : ok ? baseAtcText : BD.strings.soldOut;
      }
      const sticky = $('[data-sticky-price]', section);
      if (sticky) sticky.textContent = formatMoney(total + extra);
      renderMix(qty);
    }

    function markAvailability() {
      const sel = selectedOptions();
      optionSets.forEach((fs, idx) => {
        $$('input', fs).forEach(inp => {
          const test = sel.slice(); test[idx] = inp.value;
          const match = product.variants.find(v => v.options.every((o, k) => test[k] === undefined || o === test[k]));
          inp.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    optionSets.forEach(fs => fs.addEventListener('change', () => {
      const sel = selectedOptions();
      const out = $('[data-option-selected]', fs); if (out) out.textContent = $('input:checked', fs)?.value || '';
      variant = product.variants.find(v => v.options.every((o, k) => o === sel[k])) || null;
      if (variant) {
        idInput.value = variant.id;
        const url = new URL(location.href);
        if (box.dataset.productUrl && url.pathname.indexOf('/products/') > -1) { url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
        if (fs === designSet) applyDesign(variant.options[designIdx], true);
        else if (variant.featured_media && gallery?.goToMedia) gallery.goToMedia(variant.featured_media.id);
      }
      markAvailability();
      render();
    }));
    addonInputs.forEach(a => a.addEventListener('change', () => { render(); if (a.checked) a.closest('.addon')?.animate?.([{ transform: 'scale(.98)' }, { transform: 'scale(1)' }], { duration: 160 }); }));
    bundleInputs.forEach(i => i.addEventListener('change', () => { render(); i.closest('.bundle')?.animate?.([{ transform: 'scale(.98)' }, { transform: 'scale(1)' }], { duration: 180 }); }));

    if (form) form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!variant || !variant.available) return;
      atc.classList.add('is-loading'); atc.disabled = true;
      const stickyBtn = $('[data-sticky-atc-btn]', section); stickyBtn?.classList.add('is-loading');
      try {
        const fd = new FormData(form);
        const props = {};
        for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
        const qty = Number(qtyInput?.value) || 1;
        let items = [{ id: variant.id, quantity: qty, properties: props }];
        if (designIdx > -1 && qty > 1 && mixPicks.length === qty) {
          const counts = new Map();
          mixPicks.forEach(n => { const v = variantForDesign(n) || variant; counts.set(v.id, (counts.get(v.id) || 0) + 1); });
          items = [...counts].map(([id, q]) => ({ id, quantity: q, properties: props }));
        }
        addonInputs.filter(a => a.checked).forEach(a => items.push({ id: Number(a.value), quantity: 'per' in a.dataset ? qty : 1 }));
        // free coloring pack bonus ($0 product): add it once per cart
        const promoEl = $('[data-promo]', box);
        if (promoEl) {
          const pv = Number(promoEl.dataset.promoVariant);
          try { const c = await fetch('/cart.js').then(r => r.json()); if (!c.items.some(i => i.variant_id === pv)) items.push({ id: pv, quantity: 1 }); } catch (e) {}
        }
        await addToCart(items);
        addonInputs.forEach(a => { a.checked = false; });
        toast(BD.strings.added);
        openDrawer('CartDrawer');
      } catch (err) {
        toast(err.message || BD.strings.error);
      } finally {
        atc.classList.remove('is-loading'); stickyBtn?.classList.remove('is-loading'); render();
      }
    });

    // sticky add-to-cart
    const sticky = $('[data-sticky-atc]', section);
    if (sticky && atc && 'IntersectionObserver' in window) {
      const footer = $('.footer');
      let atcOut = false, footerIn = false;
      const update = () => {
        const show = atcOut && !footerIn;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-sticky-atc-btn]', sticky).tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(([e]) => { atcOut = !e.isIntersecting; update(); }).observe(atc);
      if (footer) new IntersectionObserver(([e]) => { footerIn = e.isIntersecting; update(); }).observe(footer);
      $('[data-sticky-atc-btn]', sticky).addEventListener('click', () => form?.requestSubmit ? form.requestSubmit() : form?.submit());
    }

    markAvailability();
    render();
    if (designIdx > -1 && variant) applyDesign(variant.options[designIdx], false);
  }

  /* ---------- Delivery estimate ---------- */
  function initEta(el) {
    const cutoff = Number(el.dataset.cutoff), proc = Number(el.dataset.processing), min = Number(el.dataset.min), max = Number(el.dataset.max);
    const weekends = el.dataset.weekends === 'true';
    const isWork = d => weekends || (d.getDay() !== 0 && d.getDay() !== 6);
    const addDays = (d, n) => { const x = new Date(d); let left = n; while (left > 0) { x.setDate(x.getDate() + 1); if (isWork(x)) left--; } return x; };
    const fmt = (d, o) => d.toLocaleDateString(undefined, o);
    const render = () => {
      const now = new Date();
      let start = new Date(now);
      const beforeCutoff = isWork(now) && now.getHours() < cutoff;
      // Ships the next business day after the order (within 24h on weekdays), regardless of cutoff.
      const ship = proc > 0 ? addDays(start, proc) : (beforeCutoff ? start : addDays(start, 1));
      const d1 = addDays(ship, min), d2 = addDays(ship, max);
      const short = { month: 'short', day: 'numeric' };
      const shipTxt = fmt(ship, { weekday: 'short', month: 'short', day: 'numeric' });
      const txt = $('[data-eta-text]', el);
      if (txt) {
        if (beforeCutoff) {
          const cut = new Date(now); cut.setHours(cutoff, 0, 0, 0);
          const ms = cut - now, h = Math.floor(ms / 36e5), m = Math.floor(ms / 6e4) % 60;
          txt.innerHTML = `Order within <b>${h}h ${m}m</b> and it ships <b>${shipTxt}</b>`;
        } else {
          txt.innerHTML = `Order now and it ships <b>${shipTxt}</b>`;
        }
      }
      const s1 = $('[data-eta-d1]', el), s2 = $('[data-eta-d2]', el);
      if (s1) s1.textContent = fmt(ship, short);
      if (s2) s2.textContent = `${fmt(d1, short)} – ${fmt(d2, short)}`;
      const x = $('[data-eta-deadline]', el);
      if (x) { const end = Number(x.dataset.etaDeadline) * 1000 + 864e5; if (end && Date.now() > end) x.remove(); }
    };
    render(); setInterval(render, 30000);
  }

  /* ---------- Before / after ---------- */
  function initBA(ba) {
    const range = $('[data-ba-range]', ba);
    const set = v => ba.style.setProperty('--pos', v + '%');
    range.addEventListener('input', () => { ba.classList.add('is-touched'); set(range.value); });
    // gentle hint animation once visible
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return; io.disconnect();
        const frames = [50, 22, 78, 50]; let i = 0;
        const step = () => {
          if (ba.classList.contains('is-touched') || i >= frames.length - 1) return;
          const from = frames[i], to = frames[i + 1], t0 = performance.now(), dur = 700;
          const anim = (t) => {
            if (ba.classList.contains('is-touched')) return;
            const p = Math.min(1, (t - t0) / dur), ease = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
            const v = from + (to - from) * ease; set(v); range.value = v;
            if (p < 1) requestAnimationFrame(anim); else { i++; setTimeout(step, 120); }
          };
          requestAnimationFrame(anim);
        };
        setTimeout(step, 400);
      }, { threshold: 0.5 });
      io.observe(ba);
    }
  }

  /* ---------- Reels ---------- */
  function initReels(wrap) {
    const vids = $$('video', wrap);
    if (!vids.length) return;
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => entries.forEach(e => {
        const v = e.target;
        if (e.isIntersecting && e.intersectionRatio > 0.6) { if (v.preload === 'none') v.preload = 'auto'; v.play().catch(() => {}); }
        else v.pause();
      }), { threshold: [0, 0.6, 1] });
      vids.forEach(v => io.observe(v));
    }
    $$('[data-reel-sound]', wrap).forEach(btn => btn.addEventListener('click', () => {
      const v = $('video', btn.closest('.reel'));
      const turnOn = v.muted;
      vids.forEach(o => { o.muted = true; });
      $$('[data-reel-sound]', wrap).forEach(b => b.classList.remove('is-on'));
      if (turnOn) { v.muted = false; v.play().catch(() => {}); btn.classList.add('is-on'); }
    }));
  }

  /* ---------- Reviews ---------- */
  function initReviews(wrap) {
    const cards = $$('[data-review]', wrap);
    const more = $('[data-reviews-more]', wrap);
    const size = Number(wrap.dataset.pageSize) || 4;
    let filter = 'all', limit = size;
    const apply = () => {
      const match = cards.filter(c => filter === 'all' || (filter === 'photos' && c.dataset.photos === 'true') || (filter.startsWith('star-') && c.dataset.stars === filter.slice(5)));
      cards.forEach(c => (c.hidden = true));
      match.forEach((c, i) => (c.hidden = i >= limit));
      if (more) more.hidden = match.length <= limit;
      $$('.rv-chip', wrap).forEach(ch => ch.classList.toggle('is-active', ch.dataset.filter === filter));
    };
    wrap.addEventListener('click', (e) => {
      const f = e.target.closest('[data-filter]');
      if (f) { filter = f.dataset.filter; limit = size; apply(); if (f.classList.contains('rv-bar')) $('.rv-list', wrap)?.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (e.target.closest('[data-reviews-more]')) { limit += size; apply(); return; }
      const h = e.target.closest('[data-helpful]');
      if (h && !h.classList.contains('is-on')) { h.classList.add('is-on'); h.lastChild.textContent = ' ' + (BD.strings.helpfulThanks || 'Thanks!'); }
    });
    apply();
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-lightbox]');
    if (t) {
      const dlg = t.closest('section')?.querySelector('[data-lightbox-dialog]') || $('[data-lightbox-dialog]');
      if (!dlg || !dlg.showModal) { window.open(t.dataset.lightbox, '_blank'); return; }
      $('[data-lightbox-img]', dlg).src = t.dataset.lightbox;
      $('[data-lightbox-cap]', dlg).textContent = t.dataset.caption || '';
      dlg.showModal(); return;
    }
    if (e.target.closest('[data-lightbox-close]') || e.target.matches('[data-lightbox-dialog]')) e.target.closest('dialog')?.close();
  });

  /* ---------- Scroll-to-buy buttons ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-scroll-buy]');
    if (!a) return;
    const target = $('[data-bundles]') || $('[data-buy]');
    if (!target) return;
    e.preventDefault();
    const y = target.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

  /* ---------- Boot ---------- */
  function boot() {
    initHeader();
    fixShipBar();
    initAnnouncement();
    initReveal();
    $$('[data-gallery]').forEach(initGallery);
    $$('[data-buybox]').forEach(initBuybox);
    $$('[data-eta]').forEach(initEta);
    $$('[data-ba]').forEach(initBA);
    $$('[data-reels]').forEach(initReels);
    $$('[data-reviews]').forEach(initReviews);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    const s = e.target;
    initReveal(s);
    $$('[data-gallery]', s).forEach(initGallery);
    $$('[data-buybox]', s).forEach(initBuybox);
    $$('[data-eta]', s).forEach(initEta);
    $$('[data-ba]', s).forEach(initBA);
    $$('[data-reels]', s).forEach(initReels);
    $$('[data-reviews]', s).forEach(initReviews);
    if ($('[data-announce]', s)) initAnnouncement();
  });
})();
